import React from "react";
import EffectCard from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

import isEmpty from "lodash/isEmpty";

const EffectCardEdit = (props) => {
  const { extra = {}, builder = false } = props;
  const { options = null, optionsType } = extra;

  if (!extra.effects) {
    return <UnconfiguredComponent hint="EffectTable.AddEffect" />;
  }

  if (!extra.templateId) {
    return <UnconfiguredComponent hint="EffectCard.AddTemplate" />;
  }

  if (extra.templateId === "_custom" && !extra.template) {
    return <UnconfiguredComponent hint="EffectCard.AddTemplate" />;
  }

  return <EffectCard {...props} />;
};

export default EffectCardEdit;
